import { Component, Inject } from "@angular/core";
import {
  MatSnackBarRef,
  MAT_SNACK_BAR_DATA
} from "@angular/material/snack-bar";

export interface SlowQuoteToastData {
  anyReady: boolean;
  showMascot: boolean;
  waitingCount: number;
}

@Component({
  selector: "app-slow-quote-toast",
  templateUrl: "./slow-quote-toast.component.html",
  styleUrls: ["./slow-quote-toast.component.scss"]
})
export class SlowQuoteToastComponent {
  constructor(
    public snackBarRef: MatSnackBarRef<SlowQuoteToastComponent>,
    @Inject(MAT_SNACK_BAR_DATA) public data: SlowQuoteToastData
  ) {}
}
